module.exports = __webpack_public_path__ + "img/skier-type-2.58f57d11.png";